// removed by extract-text-webpack-plugin
module.exports = {"announcement-card-container":"announcement-card-container","announcement-card-list":"announcement-card-list","card":"card","content":"content","title":"title","publish-info":"publish-info","date":"date","send-to":"send-to","icon-trash":"icon-trash","icon-pencil":"icon-pencil","icon-mail":"icon-mail","send-to-name":"send-to-name","title-draft":"title-draft","title-publish":"title-publish","card-footer":"card-footer","sent":"sent","send-btn":"send-btn"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Announcement/AnnouncementCard.scss
// module id = cNYk
// module chunks = 0